import { styled } from "@mui/material/styles";
import { FormHelperText } from "@mui/material";

const StyledFormHelperText = styled(FormHelperText, {
})(({ theme }) => ({
  "&.MuiFormHelperText-root": {
    color: theme.palette["black_solid"]["70"],
    fontSize: theme.typography["helperText"]["fontSize"],
    fontWeight: theme.typography["helperText"]["fontWeight"],
    margin: "5px 0 0 0",
    whiteSpace: "nowrap",
    "&.Mui-error": {
      color: theme.palette["error"]["60"]
    },
    "&.Mui-disabled": {
      color: theme.palette["black_opacity"]["40"]
    },
  },
})); 

export default StyledFormHelperText;